import * as React from 'react';
// @ts-ignore
import ProgressBar from 'react-percent-bar';

export interface ProgressProps {
  initialAnimation?: boolean;
  classForPercentage?: (percentage: number) => string;
  percentage: number;
  strokeWidth?: number;
  textForPercentage?: (percentage: number) => string;
}

export interface ProgressState {
  percentage: number;
}

export class Progress extends React.Component<ProgressProps, ProgressState> {
  static defaultProps = {
    strokeWidth: 8,
    textForPercentage: (percentage: number) => `${percentage}%`,
    initialAnimation: false,
  };
  initialTimeout: any;
  requestAnimationFrame: any;
  state: ProgressState = {
    percentage: 0,
  };
  constructor(props: ProgressProps) {
    super(props);
    this.state = {
      percentage: props.initialAnimation ? 0 : props.percentage,
    };
  }

  componentDidMount() {
    if (this.props.initialAnimation) {
      this.initialTimeout = setTimeout(() => {
        this.requestAnimationFrame = window.requestAnimationFrame(() => {
          this.setState({
            percentage: this.props.percentage,
          });
        });
      }, 0);
    }
  }

  componentWillReceiveProps(nextProps: ProgressProps) {
    this.setState({
      percentage: nextProps.percentage,
    });
  }

  componentWillUnmount() {
    clearTimeout(this.initialTimeout);
    window.cancelAnimationFrame(this.requestAnimationFrame);
  }

  render() {
    // const radius = 50 - this.props.strokeWidth! / 2;
    // const pathDescription = `
    //   M 50,50 m 0,-${radius}
    //   a ${radius},${radius} 0 1 1 0,${2 * radius}
    //   a ${radius},${radius} 0 1 1 0,-${2 * radius}
    // `;

    // const diameter = Math.PI * 2 * radius;
    // const progressStyle = {
    //   strokeDasharray: `${diameter}px ${diameter}px`,
    //   strokeDashoffset: `${((100 - this.state.percentage) / 100) * diameter}px`,
    // };

    return (
      <>
        <div>Upload Progress: {this.props.textForPercentage!(this.props.percentage)}</div>
        <ProgressBar
          colorShift={true}
          fillColor="#2b1a41"
          percent={this.props.textForPercentage!(this.props.percentage)}
        />
      </>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/components/Progress/Progress.tsx